import React from "react";
import { Link } from "react-router-dom";
import { PageLayout } from "../../../components";
import { useSelector, useDispatch } from "react-redux";
import {
  getSourceSystemContent,
  selectAppraisal
} from "../../../store/selectors";
import { getErrorMessage } from "../../../errors";
import { appraisalSlice } from "../../../store/slices/Appraisal";

export default function Error() {
  const { error } = useSelector(selectAppraisal);
  const { message, innerMessage, btnlabel, redirectUrl, linkCopy, linkUrl } =
    getErrorMessage(error);
  const { errorUri } = useSelector(getSourceSystemContent);
  const dispatch = useDispatch();

  return (
    <PageLayout>
      <PageLayout.Header title="Sorry" step={0} />
      <div className="ch-container ch-mt--4 md:ch-width--4 sm:ch-width--5 ch-width--12 sl:ch-width--8 error-page-layout--content">
        <div className="error-icon-warning ch-display--block" />
        <p className="ch-text--bold ch-fs--4 ch-pl--2 ch-pr--2 ch-mt--3 error-lh--28 ch-text--center">
          {message}
        </p>
        <div className="ch-pl--2 ch-pr--2 ch-fs--2 ch-mb--2 ch-text--center">
          <p>{innerMessage}</p>
          {linkUrl && (
            <>
              {" "}
              <a href={linkUrl} target="_blank" rel="noopener noreferrer">
                <button className="ch-btn--link ch-pa--0 ch-mt--1">
                  {linkCopy}
                </button>
              </a>
            </>
          )}
        </div>
      </div>
      <div className="error-page-layout--bottom-fixed ch-bg--grey-1">
        {redirectUrl ? (
          <Link
            to={redirectUrl}
            onClick={() => dispatch(appraisalSlice.actions.clearError())}
            className="ch-btn ch-btn--block ch-mh--auto sm:ch-width--5 md:ch-width--4 ch-width--12"
          >
            {btnlabel}
          </Link>
        ) : (
          <button
            className="ch-btn ch-btn--block ch-mh--auto sm:ch-width--5 md:ch-width--4 ch-width--12"
            onClick={() => window.location.assign(errorUri)}
          >
            {btnlabel}
          </button>
        )}
      </div>
    </PageLayout>
  );
}
